import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { CartController } from './cart.controller';
import { CartRepository, PrismaCartRepository } from './cart.repository';
import { CartService } from './cart.service';

@Module({
  imports: [AuthModule],
  controllers: [CartController],
  providers: [
    CartService,
    PrismaService,
    {
      provide: CartRepository,
      useClass: PrismaCartRepository,
    },
  ],
  exports: [CartService, CartRepository],
})
export class CartModule {}
